import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PrivatePageLayout, PageHeader } from '../../components/PrivatePage';
import { AppButtonLink } from '../../components/AppButton/AppButton';
import AutomationModal from './AutomationModal/AutomationModal';
import GridModal from './GridModal/GridModal';
import Toast from '../../components/Toast/Toast';
import { getAutomation } from '../../services/AutomationsService';

const DEFAULT_AUTOMATION = {
    symbol: '',
    conditions: '',
    actions: [],
    name: '',
    indexes: '',
};

/**
 * Dedicated bot setup shell for grid and scheduled creation/edit routes.
 * props:
 * - openType: 'grid' | 'scheduled'
 */
function Automations({ openType }) {
    const history = useHistory();
    const location = useLocation();
    const [notification, setNotification] = useState({ type: '', text: '' });
    const [editAutomation, setEditAutomation] = useState(DEFAULT_AUTOMATION);
    const [loading, setLoading] = useState(false);

    const pageMeta = {
        grid: {
            eyebrow: 'Bot setup',
            title: 'Grid bot',
            subtitle: 'Configure a range-bound grid strategy with upper and lower price limits.',
        },
        scheduled: {
            eyebrow: 'Bot setup',
            title: 'Scheduled bot',
            subtitle: 'Run trades automatically on a fixed schedule.',
        },
    };

    const meta = pageMeta[openType] || pageMeta.grid;

    useEffect(() => {
        const automationId = new URLSearchParams(location.search).get('automationId');

        if (automationId) {
            setLoading(true);
            getAutomation(automationId)
                .then((automation) => {
                    setEditAutomation(automation);
                })
                .catch((err) => {
                    console.error(err.response ? err.response.data : err.message);
                    setNotification({
                        type: 'error',
                        text: err.response ? err.response.data : err.message,
                    });
                })
                .finally(() => setLoading(false));
            return;
        }

        if (openType === 'scheduled') {
            setEditAutomation({ ...DEFAULT_AUTOMATION, schedule: new Date().toISOString() });
        } else {
            setEditAutomation({ ...DEFAULT_AUTOMATION });
        }
    }, [openType, location.search]);

    function onAutomationSubmit() {
        history.push('/bots');
    }

    return (
        <>
            <PrivatePageLayout>
                <PageHeader
                    eyebrow={meta.eyebrow}
                    title={meta.title}
                    subtitle={meta.subtitle}
                    actions={(
                        <AppButtonLink to="/bots" variant="secondary" size="md">
                            Back to bots
                        </AppButtonLink>
                    )}
                />

                {loading ? (
                    <p className="text-muted">Loading bot…</p>
                ) : null}

                {openType === 'grid' && !loading ? (
                    <GridModal data={editAutomation} onSubmit={onAutomationSubmit} inline />
                ) : null}
                {openType === 'scheduled' && !loading ? (
                    <AutomationModal data={editAutomation} onSubmit={onAutomationSubmit} inline />
                ) : null}
            </PrivatePageLayout>
            <Toast type={notification.type} text={notification.text} />
        </>
    );
}

export default Automations;